import { CircularProgress } from "@material-ui/core";
import React, { useEffect } from "react";
import { Table } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../../_metronic/_partials/controls";
import { getCareersLogsAsync } from "../../redux";

// Same status labels used on the Add/Edit Careers page.
const statusLabelMap = {
  draft: "Draft",
  published: "Published",
  pending_review: "Pending Review",
  future: "Future",
  auto_draft: "Auto Draft",
};
const getStatusLabel = (status) => {
  if (status && statusLabelMap[status]) {
    return statusLabelMap[status];
  }
  return status;
};

const CareersLog = () => {
  const { careersId } = useParams();
  const dispatch = useDispatch();
  const { isLogsLoading, logCareers, careersLogs } = useSelector(
    (state) => state.careers,
    shallowEqual
  );

  useEffect(() => {
    if (careersId) {
      dispatch(getCareersLogsAsync(careersId));
    }
  }, [careersId, dispatch]);

  return (
    <Card>
      <CardHeader
        title={
          <div className="form-group m-0 d-flex align-items-center">
            <Link className="btn btn-link px-0" to="/hfdi_careers">
              <SVG
                className="h-50 align-self-center"
                src={toAbsoluteUrl("/media/svg/icons/Navigation/Arrow-left.svg")}
              />
              Back
            </Link>
            <span className="pl-2">HFDI Careers - Careers History</span>
          </div>
        }
      ></CardHeader>
      <CardBody>
        {isLogsLoading ? (
          <div style={{ flex: "0 0 auto" }}>
            <div style={{ justifyContent: "center" }} className="text-center">
              <div className="basic-verification-loader text-center">
                <CircularProgress />
              </div>
            </div>
          </div>
        ) : !logCareers?._id ? (
          <div className="text-center py-5">Careers not found.</div>
        ) : (
          <>
            <div className="mb-5">
              <div className="font-weight-bold">
                Careers Title:{" "}
                <span className="font-weight-normal">{logCareers.title}</span>
              </div>
              <div className="font-weight-bold">
                Current Status:{" "}
                <span
                  className="font-weight-normal"
                  style={{ textTransform: "capitalize" }}
                >
                  {getStatusLabel(logCareers.status)}
                </span>
              </div>
            </div>
            <div>
              <Table
                hover
                responsive
                className="mb-0 default_table with_hoverbtn mrpdng_tbl"
              >
                <thead>
                  <tr>
                    <th>Old Status</th>
                    <th>New Status</th>
                    <th>Updated By</th>
                    <th>Login Email ID</th>
                    <th>Action</th>
                    <th>Update Time</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {careersLogs && careersLogs.length ? (
                    careersLogs.map((log) => (
                      <tr key={log._id}>
                        <td style={{ textTransform: "capitalize" }}>
                          {getStatusLabel(log.oldStatus)}
                        </td>
                        <td style={{ textTransform: "capitalize" }}>
                          {getStatusLabel(log.newStatus)}
                        </td>
                        <td>{log.loginName}</td>
                        <td>{log.loginEmailID}</td>
                        <td>{log.action}</td>
                        <td>{new Date(log.updateTime).toLocaleString()}</td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {log.newData ? (
                            <Link
                              className="btn btn-sm btn-light-primary"
                              to={`/hfdi_careers_log/${careersId}/${log._id}/new`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              Careers Details log
                            </Link>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-sm btn-light"
                              disabled
                              title="No data after this action"
                            >
                              New Careers
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={7} className="text-center">
                        No history found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </>
        )}
      </CardBody>
    </Card>
  );
};

export default CareersLog;
